import React, { useState } from 'react';
import PropTypes from 'prop-types';

export default function HouseholdGoodsSection({ items, onAdd, onEdit, onDelete }) {
  const [isDescOpen, setIsDescOpen] = useState(false);

  return (
    <section className="space-y-8 mt-12">
      <header
        onClick={() => setIsDescOpen(open => !open)}
        className="sticky top-0 z-10 bg-gray-100 w-full p-4 rounded-md cursor-pointer select-none flex items-center justify-between"
      >
        <h2 className="text-2xl font-semibold">Household Goods</h2>
        <button
          onClick={onAdd}
          className="px-4 py-1 bg-blue-600 text-white rounded"
        >
          Add Household Item
        </button>
      </header>
      {isDescOpen && (
        <div className="bg-white border border-gray-200 rounded-md p-4 mb-6 space-y-2">
          <p><strong>Household goods and furnishings</strong><br/>
            Examples: Major appliances, furniture, linens, china, kitchenware
          </p>
          <p><strong>Electronics</strong><br/>
            Examples: Televisions and radios; audio, video, stereo, and digital equipment; computers, printers, scanners; music collections; electronic devices including cell phones, cameras, media players, games
          </p>
          <p><strong>Collectibles of value</strong><br/>
            Examples: Antiques and figurines; paintings, prints, or other artwork; books, pictures, or other art objects; stamp, coin, or baseball card collections; other collections, memorabilia, collectibles
          </p>
          <p><strong>Equipment for sports and hobbies</strong><br/>
            Examples: Sports, photographic, exercise, and other hobby equipment; bicycles, pool tables, golf clubs, skis; canoes and kayaks; carpentry tools; musical instruments
          </p>
          <p><strong>Firearms</strong><br/>
            Examples: Pistols, rifles, shotguns, ammunition, and related equipment
          </p>
          <p><strong>Clothes</strong><br/>
            Examples: Everyday clothes, furs, leather coats, designer wear, shoes, accessories
          </p>
          <p><strong>Jewelry</strong><br/>
            Examples: Everyday jewelry, costume jewelry, engagement rings, wedding rings, heirloom jewelry, watches, gems, gold, silver
          </p>
          <p><strong>Non-farm animals</strong><br/>
            Examples: Dogs, cats, birds, horses
          </p>
          <p><strong>Other personal and household items</strong><br/>
            Examples: Any other personal and household items you did not already list, including any health aids you did not list
          </p>
        </div>
      )}
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
        {items.map(item => (
          <div
            key={item.id}
            className="bg-white rounded-lg shadow-md p-6 hover:shadow-lg transition-shadow flex flex-col"
          >
            <h3 className="text-lg font-semibold mb-2">
              {item.category.replace('_', ' ').toUpperCase()}
            </h3>
            <ul className="space-y-1 text-sm text-gray-700 mb-4">
              <li>
                <strong>Description:</strong> {item.description || '–'}
              </li>
              <li>
                <strong>Value:</strong>{' '}
                ${item.value != null ? parseFloat(item.value).toFixed(2) : '0.00'}
              </li>
              <li>
                <strong>Exemption Code:</strong> {item.exemption_code || '–'}
              </li>
              <li>
                <strong>Exemption Amt:</strong>{' '}
                ${item.exemption_amount != null
                  ? parseFloat(item.exemption_amount).toFixed(2)
                  : '0.00'}
              </li>
            </ul>
            <div className="mt-auto flex space-x-2">
              <button
                onClick={() => onEdit(item)}
                className="px-3 py-1 bg-yellow-500 text-white rounded"
              >
                Edit
              </button>
              <button
                onClick={() => onDelete(item.id)}
                className="px-3 py-1 bg-red-600 text-white rounded"
              >
                Delete
              </button>
            </div>
          </div>
        ))}
      </div>
    </section>
  );
}

HouseholdGoodsSection.propTypes = {
  items: PropTypes.array.isRequired,
  onAdd: PropTypes.func.isRequired,
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
